import { Box, Grid } from '@mui/material';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EmpEmeContactType } from '../../data';
import { IFormInput } from '../../useEmergencyContact';

import { useSxStyles } from './useStyles';

type Props = {
  data: EmpEmeContactType;
  register: UseFormRegister<IFormInput>;
  errors: FieldErrors<IFormInput>;
};

export const EmergencyContactEditMode = ({
  data: emp,
  register,
  errors,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  return (
    <div>
      <Box component="table" sx={sxStyles.tableEdit}>
        <tbody>
          <tr>
            <td>
              <Box component="label" htmlFor="fEmpEmeName" sx={sxStyles.label}>
                {t('fEmpEmeName')}:
              </Box>
            </td>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.inputTableItem}>
              <Box
                component="input"
                {...register('fEmpEmeName')}
                type="text"
                sx={errors.fEmpEmeName ? sxStyles.errorMsg : sxStyles.input}
                defaultValue={emp?.fEmpEmeName}
              />
            </Box>
          </tr>
          <tr>
            <td>
              {errors.fEmpEmeName && (
                <Grid item>
                  <Box component="span" sx={sxStyles.errorMsgText}>
                    {errors.fEmpEmeName.message}
                  </Box>
                </Grid>
              )}
            </td>
          </tr>
          <tr>
            <td>
              <Box component="label" htmlFor="fEmpEmePhone" sx={sxStyles.label}>
                {t('fEmpEmePhone')}:
              </Box>
            </td>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.inputTableItem}>
              <Box
                component="input"
                {...register('fEmpEmePhone')}
                type="text"
                sx={errors.fEmpEmePhone ? sxStyles.errorMsg : sxStyles.input}
                defaultValue={emp?.fEmpEmePhone}
              />
            </Box>
          </tr>
          <tr>
            <td>
              {errors.fEmpEmePhone && (
                <Grid item>
                  <Box component="span" sx={sxStyles.errorMsgText}>
                    {errors.fEmpEmePhone.message}
                  </Box>
                </Grid>
              )}
            </td>
          </tr>
          <tr>
            <td>
              <Box component="label" htmlFor="fEmpEmeEmail" sx={sxStyles.label}>
                {t('fEmpEmeEmail')}:
              </Box>
            </td>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.inputTableItem}>
              <Box
                component="input"
                {...register('fEmpEmeEmail')}
                type="text"
                sx={errors.fEmpEmeEmail ? sxStyles.errorMsg : sxStyles.input}
                defaultValue={emp?.fEmpEmeEmail}
              />
            </Box>
          </tr>
          <tr>
            <td>
              {errors.fEmpEmeEmail && (
                <Grid item>
                  <Box component="span" sx={sxStyles.errorMsgText}>
                    {errors.fEmpEmeEmail.message}
                  </Box>
                </Grid>
              )}
            </td>
          </tr>
        </tbody>
      </Box>
    </div>
  );
};
